module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAYAAACaq43EAAAAO0lEQVRIx2OU22r1n2EAAOOoxaMW08zipmuTjg2Ixf+BYNTiUYuHl8Xq7ecHJjsxFB37P2rxqMXDymIAXTE2gktm+K8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/sl.png
// module id = 922
// module chunks = 0